import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { from, lastValueFrom, Observable } from 'rxjs';
import { AppContext } from '../../../00_modules/contextbar/services/app-context/models/app-context.model';
import { NavigationItem } from '../../../00_modules/contextbar/services/navigation/models/navigation-item.model';
import { NavigationResolver } from '../../../00_modules/contextbar/services/navigation/resolver/navigation.resolver';
import { map, switchMap, take } from 'rxjs/operators';
import { ContextBarStateService } from '../../../00_modules/contextbar/statemanagement/contextbar-state.service';
import { RouterModule } from '@angular/router';
import { ContextBarNavigationBadgeComponent } from '../context-bar-navigation-badge/context-bar-navigation-badge.component';
import { ActiveRouteResolverStrategy } from '../../../00_modules/contextbar/services/navigation';
import { NotificationService } from '../../../00_modules/core/services/notification.service';
import { ActiveFormFacade } from '../../../store/facade/active-form.facade';

@Component({
    selector: 'je-context-navigation',
    imports: [CommonModule, RouterModule, ContextBarNavigationBadgeComponent, TranslateModule],
    templateUrl: './context-navigation.component.html',
})
export class ContextNavigationComponent {
    public navigation: NavigationItem[];
    protected readonly activeRouteResolverStrategy = ActiveRouteResolverStrategy;

    constructor(
        private navigationResolver: NavigationResolver,
        private contextBarStateService: ContextBarStateService,
        private notificationService: NotificationService,
        private activeFormFacade: ActiveFormFacade,
    ) {}

    @Input()
    public set appContext$(value: Observable<AppContext>) {
        if (!value) {
            return;
        }
        value.pipe(switchMap(context => from(this.navigationResolver.getNavigation(context)))).subscribe(navigation => {
            this.navigation = navigation;
        });
    }

    public getRouterLink(item): string {
        return '/' + item.route.join('/');
    }

    public onNavigationElementClicked(item): void {
        this.contextBarStateService.setSelectedNavigationKey(item.key);
    }

    public isItemSelected(item: NavigationItem) {
        return this.contextBarStateService.selectedNavigationKey$.pipe(map(selectedKey => item.key === selectedKey));
    }

    public async itemClicked(item: NavigationItem): Promise<boolean> {
        event.stopPropagation();

        const activeFormState = await lastValueFrom(this.activeFormFacade.formState$.pipe(take(1)));
        if (activeFormState.hasActiveForm && activeFormState.isDirty && !activeFormState.isValid) {
            await this.notificationService.errorTranslate('INPUT_ERRORS.HAS_ERRORS');
            this.activeFormFacade.formSetIsSubmitted(true);
        } else {
            this.contextBarStateService.setSelectedNavigationKey(item.key);
        }

        return false;
    }
}
